import { EditContentOutDto, EditContentInDto } from '../../../types/content.dto'

export const EDIT_CONTENT = 'EDIT_CONTENT'
export const EDIT_CONTENT_SUCCESS = 'EDIT_CONTENT_SUCCESS'
export const EDIT_CONTENT_ERROR = 'EDIT_CONTENT_ERROR'
export const RESET_EDIT_CONTENT = 'RESET_EDIT_CONTENT'

export interface EditContent {
  type: typeof EDIT_CONTENT
  payload: EditContentOutDto
}

export interface EditContentSuccess {
  type: typeof EDIT_CONTENT_SUCCESS
  payload: EditContentInDto
}

export interface EditContentError {
  type: typeof EDIT_CONTENT_ERROR
  payload: string | boolean
}

export interface ResetEditContent {
  type: typeof RESET_EDIT_CONTENT
  payload: null
}
export interface State {
  data: EditContentInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditContent | EditContentSuccess | EditContentError | ResetEditContent
